// Browser-compatible email service using Mailjet API directly
const sendEmail = async (email, name, message, subject = 'New Contact Form Submission') => {
    try {
        // Get environment variables from React app
        const apiKey = process.env.REACT_APP_MJ_APIKEY_PUBLIC;
        const apiSecret = process.env.REACT_APP_MJ_APIKEY_PRIVATE;
        const recipientEmail = process.env.REACT_APP_MJ_RECIPIENT_EMAIL || 'admin@gmnexus.com';

        if (!apiKey || !apiSecret) {
            throw new Error('Mailjet API credentials not configured');
        }

        // Create base64 encoded credentials
        const credentials = btoa(`${apiKey}:${apiSecret}`);
        
        const response = await fetch('https://api.mailjet.com/v3.1/send', {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${credentials}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                Messages: [
                    {
                        From: {
                            Email: email,
                            Name: 'GMNexus Contact Form'
                        },
                        To: [
                            {
                                Email: recipientEmail,
                                Name: 'GMNexus Admin'
                            }
                        ],
                        Subject: subject,
                        TextPart: `
                            Name: ${name}
                            Email: ${email}
                            Message: ${message}
                        `,
                        HTMLPart: `
                            <h3>New Contact Form Submission</h3>
                            <p><strong>Name:</strong> ${name}</p>
                            <p><strong>Email:</strong> ${email}</p>
                            <p><strong>Message:</strong></p>
                            <p>${message}</p>
                        `,
                        CustomID: `contact_form_${Date.now()}`
                    }
                ]
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.ErrorMessage || `HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('Email sent successfully:', result);
        return { success: true, data: result };
    } catch (err) {
        console.error('Error sending email:', err);
        return { success: false, error: err.message || 'Failed to send email' };
    }
};

export default sendEmail;
